<template>
  <div>
    <div class="text-bold q-mb-sm">API Key:</div>
    <masked-api-key
      :service-account="serviceAccount"
      @update:service-account="$emit('update:service-account', $event)"
    />
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ServiceAccount } from '@/iam/types';
import MaskedApiKey from './MaskedApiKey.vue';

export default defineComponent({
  emits: ['update:service-account'],
  components: { MaskedApiKey },
  props: {
    serviceAccount: {
      type: Object as () => ServiceAccount,
      required: true,
    },
  },
});
</script>
